import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const ns = 'navigation';
export const useNavigationTranslation = (): UseTranslationResponse<
  typeof ns
> => useTranslation(ns);

const reused = {
  latest_events: '$t(последние события)',
  event_archive: '$t(архив событий)',
  search: '$t(поиск)',
  checks: '$t(checks:page.title.checks)',
  queues: '$t(очереди)',
  event_statistic: '$t(статистика)',
  faces: '$t(лица)',
  lists: '$t(списки)',
  fs_sources: '$t(источники событий)',
  handlers: '$t(сценарии)',
  tasks: '$t(задачи)',
  accounts: '$t(пользователи)',
  monitoring: '$t(мониторинг)',
  features: '$t(common:features)',
  notifications: '$t(уведомления)',
  vareporter_plans: '$t(планы)',
  vareporter_reports: '$t(отчеты)',
  verifiers: '$t(верификация)',
  search_by_documents: '$t(поиск по документам)',
  departments: '$t(отделения)',
  thermo: '$t(Термо)',
  plugins: '$t(plugins:title)',
};

export const ruRu = (__LOCALE_RU__ ? ({
  ...reused,
  events_and_video: 'События и видео',
  settings_and_catalogs: 'Настройки и справочники',
  administration: 'Администрирование',
  other: '',
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  ...reused,
  events_and_video: 'Events and Video',
  settings_and_catalogs: 'Settings and Catalogs',
  administration: 'Administration',
  other: '',
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  ...reused,
  events_and_video: 'Eventos y vídeo',
  settings_and_catalogs: 'Configuración y catálogos',
  administration: 'Administración',
  other: '',
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  ...reused,
  events_and_video: 'Eventos e Vídeos',
  settings_and_catalogs: 'Configurações e Catálogos',
  administration: 'Administração',
  other: '',
}) : {}) as Record<string, unknown>;
